import { render } from "./uploading.vue?vue&type=template&id=04f0681a&ts=true"
import script from "./uploading.vue?vue&type=script&lang=ts"
export * from "./uploading.vue?vue&type=script&lang=ts"

import "./uploading.vue?vue&type=style&index=0&id=04f0681a&lang=scss"

import exportComponent from "D:\\alicode\\alicom-hall\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__